import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { AttachmentsPortalService } from '../../services/attachment-portal.service';
import { AttachmentPage } from './attachment/attachment.page';
import {CommonFeModule} from "../../../../../pastureProFECommon/projects/common-lib/src/lib/common-fe.module";
import {AttachmentsListPage} from "./attachments/attachments-list.page";
import {AttachmentListModule} from "../../components/attachment-list/attachment-list.module";


@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonFeModule,
    AttachmentListModule,
  ],
  declarations: [
    AttachmentPage,
    AttachmentsListPage
  ],
  providers: [
    AttachmentsPortalService,
  ]
})
export class AttachmentsPageModule {
}
